import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'


import { Product, useProductsPreviewCardQuery } from '@shared/generated'

export type ProductListInfo = {
  mode: 'group' | 'ids'
  xids: string[]
  productGroupId?: string
  title?: string
}

type ProductListProps = {
  data: ProductListInfo
  className?: string
}


export default function ProductList ({
  data,
  className
}: ProductListProps) {
  const { shopId } = useAddressStore()


  const { data: productsData, loading } = useProductsPreviewCardQuery({
    variables: {
      shopId,
      filter: {
        or: [
          {
            fields: [ 'productGroupIds' ],
            op: 'eq',
            value: [ data.productGroupId ]
          },
          {
            fields: [ 'xid' ],
            op: 'contains',
            value: data.xids
          }
        ]
      }
    }
  })

  const products = productsData?.products?.edges as Product[] || []

  if (!products || !Array.isArray(products)) {
    return null
  }

  return (
    <div className={className}>
      <ProductCarousel
        title={data.title}
        products={products || []}
        loading={loading}
      />
    </div>
  )
}
